// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1HCvx","search":"Settings_search__ejmya","filter":"Settings_filter__IMfKz"};